import React from 'react';
import { Flower2, Instagram, Facebook, MapPin, Phone, Mail, ArrowUp } from 'lucide-react';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-yoga-dark text-white pt-20 pb-10 relative" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-177">
          {/* Brand Col */}
          <div className="lg:col-span-1" data-id="element-178">
            <div className="flex items-center gap-2 mb-6" data-id="element-179">
              <Flower2 className="w-8 h-8 text-yoga-primary" data-id="element-180" />
              <span className="text-2xl font-bold tracking-wide" data-id="element-181">
                Shree Yoga
              </span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-182">
              Transforming lives through the ancient wisdom of yoga, adapted for
              modern lifestyles in Pune.
            </p>
            <div className="flex gap-4" data-id="element-183">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-yoga-primary transition-colors" data-id="element-184">
                <Instagram className="w-5 h-5" data-id="element-185" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-yoga-primary transition-colors" data-id="element-186">
                <Facebook className="w-5 h-5" data-id="element-187" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-188">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-189">Quick Links</h4>
            <ul className="space-y-4" data-id="element-190">
              <li data-id="element-191">
                <a href="#home" className="text-gray-400 hover:text-yoga-primary transition-colors" data-id="element-192">
                  Home
                </a>
              </li>
              <li data-id="element-193">
                <a href="#about" className="text-gray-400 hover:text-yoga-primary transition-colors" data-id="element-194">
                  About Instructor
                </a>
              </li>
              <li data-id="element-195">
                <a href="#schedule" className="text-gray-400 hover:text-yoga-primary transition-colors" data-id="element-196">
                  Class Schedule
                </a>
              </li>
              <li data-id="element-197">
                <a href="#testimonials" className="text-gray-400 hover:text-yoga-primary transition-colors" data-id="element-198">
                  Testimonials
                </a>
              </li>
              <li data-id="element-199">
                <a href="#gallery" className="text-gray-400 hover:text-yoga-primary transition-colors" data-id="element-200">
                  Gallery
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-201">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-202">Our Services</h4>
            <ul className="space-y-4" data-id="element-203">
              <li className="text-gray-400" data-id="element-204">Hatha Yoga</li>
              <li className="text-gray-400" data-id="element-205">Power Yoga</li>
              <li className="text-gray-400" data-id="element-206">Meditation & Pranayama</li>
              <li className="text-gray-400" data-id="element-207">Yoga for Weight Loss</li>
              <li className="text-gray-400" data-id="element-208">Prenatal Yoga</li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-209">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-210">Contact Us</h4>
            <ul className="space-y-4" data-id="element-211">
              <li className="flex items-start gap-3" data-id="element-212">
                <MapPin className="w-5 h-5 text-yoga-primary shrink-0 mt-0.5" data-id="element-213" />
                <span className="text-gray-400 text-sm" data-id="element-214">
                  Sr 281, Anand Nagar, Lane 7, Kutwal Colony, Lohegaon, Pune
                  411047
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-215">
                <Phone className="w-5 h-5 text-yoga-primary shrink-0" data-id="element-216" />
                <span className="text-gray-400 text-sm" data-id="element-217">+91 87932 68867</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-218">
                <Mail className="w-5 h-5 text-yoga-primary shrink-0" data-id="element-219" />
                <span className="text-gray-400 text-sm" data-id="element-220">
                  hello@shreeyogafitness.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-221">
          <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-222">
            &copy; {new Date().getFullYear()} Shree Yoga Fitness. All rights
            reserved.
          </p>
          <p className="text-gray-500 text-sm flex items-center gap-1" data-id="element-223">
            Made with <span className="text-red-500" data-id="element-224">❤️</span> in Pune, India
          </p>
        </div>
      </div>

      {/* Scroll to top button */}
      <button onClick={scrollToTop} className="absolute bottom-8 right-8 w-12 h-12 bg-yoga-primary text-white rounded-full flex items-center justify-center shadow-lg hover:bg-yoga-light transition-colors z-50" aria-label="Scroll to top" data-id="element-225">
        <ArrowUp className="w-6 h-6" data-id="element-226" />
      </button>
    </footer>;
}